import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { MediaItemDetails } from '../media-item-details';

export class Media implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Media';
  readonly apiRoute: string = CONFIG.apiRoutes.mediaItemDetails;

  mediaId: string;
  mediaItemDetailsId: string;
  mediaItemDetails: MediaItemDetails = new MediaItemDetails();
  entityId: string;
  entityType: MediaEntityType;

  json() {
    return this;
  }

  loadFromJson(data) {
    this.mediaId = data.mediaId;
    this.mediaItemDetailsId = data.mediaItemDetailsId;

    if (data.mediaItemDetails) {
      this.mediaItemDetails = new MediaItemDetails();
      this.mediaItemDetails.loadFromJson(data.mediaItemDetails);
    }

    this.entityId = data.entityId;
    this.entityType = data.entityType;
  }
}

export enum MediaEntityType {
  OrgTreeNode = 1,
  InspectionReport = 2,
  ThicknessLocation = 3,
  RbiAnalysis = 4,
  MitigationsAnalysis = 5
}

export enum RunnableModelOrgTreeNodeType {
  Rbi = 1,
  Mitigations = 2
}
